import { parseAsArrayOf, parseAsString, useQueryStates } from "nuqs";

export const imagingResultsQueryParams = {
  imagingResultsClassification: parseAsArrayOf(parseAsString, ","),
  studyType: parseAsArrayOf(parseAsString, ","),
  imagingType: parseAsArrayOf(parseAsString, ","),
  bodyPart: parseAsArrayOf(parseAsString, ","),
  needsSignature: parseAsArrayOf(parseAsString, ","),
};

export function useImagingResultsColumnFilters() {
  return useQueryStates(imagingResultsQueryParams);
}
